import { useEffect, useState } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { Profil } from "./components/Profil";
import { Pillars } from "./components/Pillars";
import { TransparencyStats } from "./components/TransparencyStats";
import { DusunGallery } from "./components/DusunGallery";
import { NightPatrol } from "./components/NightPatrol";
import { Testimonials } from "./components/Testimonials";
import { SocialFeed } from "./components/SocialFeed";
import { VillageAgenda } from "./components/VillageAgenda";
import { AspirasiForm } from "./components/AspirasiForm";
import { FloatingWhatsApp } from "./components/FloatingWhatsApp";
import { Footer } from "./components/Footer";

function App() {
  const [dark, setDark] = useState(() => localStorage.getItem("cianjay-theme") === "dark");

  useEffect(() => {
    document.documentElement.classList.toggle("dark", dark);
    localStorage.setItem("cianjay-theme", dark ? "dark" : "light");
  }, [dark]);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="grain min-h-screen bg-bg text-ink" data-testid="app-root">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Profil />
        <Pillars />
        <TransparencyStats />
        <DusunGallery />
        <NightPatrol />
        <Testimonials />
        <SocialFeed />
        <VillageAgenda />
        <AspirasiForm />
      </main>
      <Footer dark={dark} onToggle={() => setDark(!dark)} />
      <FloatingWhatsApp />
      <Toaster position="top-center" richColors theme={dark ? "dark" : "light"} />
    </div>
  );
}

export default App;
